import { BookingExport } from './booking-export.model';
import BaseService from '../base-service';

export default class BookingExportsService extends BaseService<BookingExport> {
  get endpoint() {
    return 'booking-exports';
  }
}
